module.exports = __webpack_public_path__ + "static/media/more-all-products-2.16cf2f78.png";